import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const AdminPage = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [broadcastResult, setBroadcastResult] = useState(null);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('staff_token');

  const authFetch = useCallback(async (path, options = {}) => {
    const res = await fetch(`${API_URL}${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });
    if (res.status === 401) {
      localStorage.removeItem('staff_token');
      navigate('/staff');
      return null;
    }
    return res;
  }, [token, navigate]);

  useEffect(() => {
    if (!token) {
      navigate('/staff');
      return;
    }

    authFetch('/api/admin/stats').then(async res => {
      if (!res) return;
      const data = await res.json();
      setStats(data);
    });
  }, [token, navigate, authFetch]);

  const handleBroadcast = async (e) => {
    e.preventDefault();
    setBroadcastResult(null);
    setError(null);
    setSending(true);

    try {
      const res = await authFetch('/api/admin/broadcast', {
        method: 'POST',
        body: JSON.stringify({ subject, message }),
      });
      if (!res) return;
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Erreur lors de l\'envoi');
      } else {
        setBroadcastResult(`Email envoyé à ${data.sent} abonné(s).`);
        setSubject('');
        setMessage('');
      }
    } catch (err) {
      setError('Erreur réseau. Veuillez réessayer.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="app-container" style={{ backgroundColor: '#fff', alignItems: 'flex-start', overflowY: 'auto', padding: '2rem' }}>
      <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700 }}>Admin Durden</h1>
          <button
            className="btn-secondary"
            style={{ padding: '0.5rem 1rem', fontSize: '0.85rem' }}
            onClick={() => { localStorage.removeItem('staff_token'); navigate('/staff'); }}
          >
            Déconnexion
          </button>
        </div>

        {/* Stats */}
        {stats && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '2.5rem' }}>
            <StatCard label="Tickets créés" value={stats.totalTickets} />
            <StatCard label="Entrées validées" value={stats.attended} />
            <StatCard label="Abonnés newsletter" value={stats.newsletterSubscribers} />
          </div>
        )}

        {/* Broadcast form */}
        <div style={{ border: '1px solid #eaeaea', borderRadius: '8px', padding: '1.5rem' }}>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem' }}>Envoyer une newsletter</h2>
          <p style={{ color: '#666', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
            L'email sera envoyé à tous les abonnés ayant coché la case newsletter lors de leur inscription.
          </p>

          {error && <div className="global-error" style={{ marginBottom: '1rem' }}>{error}</div>}
          {broadcastResult && (
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '6px', padding: '0.75rem 1rem', marginBottom: '1rem', color: '#166534', fontSize: '0.875rem' }}>
              {broadcastResult}
            </div>
          )}

          <form onSubmit={handleBroadcast}>
            <div className="input-group">
              <label className="input-label">Sujet</label>
              <input
                type="text"
                value={subject}
                onChange={e => setSubject(e.target.value)}
                className="form-input"
                placeholder="Ex : Durden — Nouvelles du festival"
                required
              />
            </div>

            <div className="input-group">
              <label className="input-label">Message</label>
              <textarea
                value={message}
                onChange={e => setMessage(e.target.value)}
                className="form-input"
                style={{ minHeight: '180px', resize: 'vertical', fontFamily: 'inherit' }}
                placeholder="Rédigez votre message ici..."
                required
              />
            </div>

            <button type="submit" disabled={sending} className="btn-primary" style={{ marginTop: '0.5rem' }}>
              {sending ? <div className="spinner"></div> : `Envoyer à ${stats ? stats.newsletterSubscribers : '…'} abonné(s)`}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
};

const StatCard = ({ label, value }) => (
  <div style={{ border: '1px solid #eaeaea', borderRadius: '8px', padding: '1.25rem', textAlign: 'center' }}>
    <div style={{ fontSize: '2rem', fontWeight: 700 }}>{value}</div>
    <div style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.25rem' }}>{label}</div>
  </div>
);

export default AdminPage;
